import request from '@/utils/request'

// 获取机器人操作日志列表（管理员接口）
export function getRobotLogs(params) {
  return request({
    url: '/admin/logs',
    method: 'get',
    params
  })
}

// 获取用户自己的机器人操作日志
export function getUserRobotLogs(params) {
  return request({
    url: '/logs',
    method: 'get',
    params
  })
}

// 获取日志统计信息
export function getLogStatistics() {
  return request({
    url: '/admin/logs/statistics',
    method: 'get'
  })
}
